// ─────────────────────────────────────────────────────────────
//  Рендер markdown-ответов ИИ: react-markdown + remark-gfm
//  (таблицы, списки задач, зачёркивание). Стили подогнаны под
//  пузыри чата и карточки результатов.
// ─────────────────────────────────────────────────────────────
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { C } from '../tokens';

const mono = 'ui-monospace, SFMono-Regular, Menlo, monospace';

const components = {
  h1: ({ children }) => <h3 style={{ margin: '0.5em 0 0.3em', fontSize: 18, fontWeight: 800 }}>{children}</h3>,
  h2: ({ children }) => <h4 style={{ margin: '0.5em 0 0.3em', fontSize: 16, fontWeight: 800 }}>{children}</h4>,
  h3: ({ children }) => <h4 style={{ margin: '0.5em 0 0.3em', fontSize: 15, fontWeight: 800 }}>{children}</h4>,
  h4: ({ children }) => <h5 style={{ margin: '0.5em 0 0.3em', fontSize: 15, fontWeight: 700 }}>{children}</h5>,
  p: ({ children }) => <p style={{ margin: '0 0 0.55em', lineHeight: 1.55 }}>{children}</p>,
  ul: ({ children }) => <ul style={{ margin: '0 0 0.55em', paddingLeft: 20 }}>{children}</ul>,
  ol: ({ children }) => <ol style={{ margin: '0 0 0.55em', paddingLeft: 22 }}>{children}</ol>,
  li: ({ children }) => <li style={{ marginBottom: 3, lineHeight: 1.5 }}>{children}</li>,
  a: ({ href, children }) => (
    <a href={href} target="_blank" rel="noreferrer" style={{ color: C.blue, fontWeight: 600 }}>
      {children}
    </a>
  ),
  blockquote: ({ children }) => (
    <blockquote style={{
      borderLeft: `3px solid ${C.purple}`, margin: '0 0 0.55em',
      padding: '2px 0 2px 10px', color: C.grey, fontStyle: 'italic',
    }}>{children}</blockquote>
  ),
  code: ({ inline, children, ...props }) => (
    inline ? (
      <code style={{
        background: 'rgba(140,111,176,0.13)', borderRadius: 5,
        padding: '1px 5px', fontSize: '0.88em', fontFamily: mono,
      }} {...props}>{children}</code>
    ) : (
      <code style={{ fontFamily: mono, fontSize: '0.85em' }} {...props}>{children}</code>
    )
  ),
  pre: ({ children }) => (
    <pre style={{
      background: 'rgba(26,32,48,0.06)', borderRadius: 10,
      padding: '10px 12px', overflowX: 'auto',
      margin: '0 0 0.55em', lineHeight: 1.5,
    }}>{children}</pre>
  ),
  hr: () => <hr style={{ border: 'none', borderTop: `1px solid ${C.border}`, margin: '0.7em 0' }}/>,
  table: ({ children }) => (
    <div style={{ overflowX: 'auto', margin: '0 0 0.55em' }}>
      <table style={{ borderCollapse: 'collapse', fontSize: '0.92em' }}>{children}</table>
    </div>
  ),
  th: ({ children }) => (
    <th style={{ border: `1px solid ${C.border}`, padding: '5px 9px', textAlign: 'left', background: 'rgba(140,111,176,0.08)' }}>
      {children}
    </th>
  ),
  td: ({ children }) => (
    <td style={{ border: `1px solid ${C.border}`, padding: '5px 9px' }}>{children}</td>
  ),
};

export default function Markdown({ text }) {
  if (!text) return null;
  return (
    // отрицательный отступ гасит margin-bottom последнего абзаца
    <div style={{ marginBottom: '-0.55em' }}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
        {String(text)}
      </ReactMarkdown>
    </div>
  );
}
